<template>
  <Page>
    <Announce style="position: absolute; left: 36px; right: 36px; top: 80px; z-index: 10;" />
    <Scree1 v-if="screen == 1" @screen="enterScreen2FromScreen1" />
    <Scree2 v-if="screen == 2" />
  </Page>
</template>

<script setup>
  import {onMounted, ref} from 'vue'
  import * as Request from '@/assets/request';

  import Page from '@/components/page';
  import Announce from '@/components/announce';
  import Scree1 from './components/screen1'
  import Scree2 from './components/screen2'

  const screen = ref(1)
  // 友盟埋点：首页 PV 上报
  onMounted(() => {
    window._czc = window._czc || [];
    window._czc.push(["_trackPageview", "/dispatch"]);
  })
  // const init = async () => {
  //   const result = await Request.post({
  //     url: '/22001/facade/dispatch/machines'
  //   });
  //   console.log('result--', result)


  //   // 是否有任务判断
  //   const hasTask = false;

  //   if(hasTask) {
  //     // 创建了任务，直接进入任务页面
  //     screen.value = 2
  //   }else{
  //     // 未创建任务，进入引导创建任务
  //     screen.value = 1
  //   }
  // }
  // onMounted(() => {
  //   init()
  // })
  
  const enterScreen2FromScreen1 = () => {
    screen.value = 2
  }
</script>

<style scoped lang="less">
@import "./index.less";
</style>
